import { combineReducers } from "redux";
import corpusModeles from "./modeles/corpus-modeles";
import recentsModeles from "./modeles/recents-modeles";
import activeModeleReducer from "./active-modele-reducer";
import selectedPositionReducer from "./selected-position-reducer";
import selectedMotifReducer from "./selected-motif-reducer";
import selectedModeleReducer from "./selected-modele-reducer";
import canvasReducer from "./canvas-reducer";
// import imageDataReducer from "./image-data-reducer";
import traceReducer from "./trace-reducer";
import comparisonReducer from "./comparison-reducer";

const rootReducer = combineReducers({
    // corpusModeles,
    // recentsModeles,
    activeModele: activeModeleReducer,
    position: selectedPositionReducer,
    selectedModele: selectedModeleReducer,
    motif: selectedMotifReducer,
    trace: traceReducer,
    // imageData: imageDataReducer,
    canvas: canvasReducer,
    comparison: comparisonReducer,
});

export default rootReducer;
